import { sendPostRequest } from "../services/FetchService";
import * as FETCHAPI from "../constants/FetchApi";

export const requestFeature = (featureData) => {
  return sendPostRequest(FETCHAPI.REQUEST_FEATURE, featureData);
};
